import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { ColaboradorService } from 'src/app/services/colaborador.service';
import { Auth } from 'src/app/models/auth';
import { CartaoService } from 'src/app/services/cartao.service';
import { ContratoService } from 'src/app/services/contrato.service';
import { ApiError } from 'src/app/shared/enums/api-error.enum';
import { CartaoCadastroLote } from 'src/app/models/cartao-cadastro-lote';
import { CartaoCadastroItem } from 'src/app/models/cartao-cadastro-item';
import { ColaboradoresId } from 'src/app/models/colaborador-ids';
import { CartaoCadastro } from 'src/app/models/cartao-cadastro';
import { CartaoPeriodoPadrao } from 'src/app/shared/enums/cartao-periodo-padrao.enum';
import { FiltroColaboradorService } from 'src/app/services/filtro-colaborador.service';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';

@Component({
    selector: 'app-colaborador-cartao-lote',
    templateUrl: './colaborador-cartao-lote.component.html',
    styleUrls: ['./colaborador-cartao-lote.component.css']
})
export class ColaboradorCartaoLoteComponent implements OnInit, OnDestroy {

    public erroValor = false;

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private authenticationService: AuthenticationService,
        private colaboradorService: ColaboradorService,
        private alertService: NewAlertService,
        private cartaoService: CartaoService,
        private contraotoService: ContratoService,
        private filterService: FiltroColaboradorService) {
    }

    private colaboradorId: number;
    private urlReturn = null;
    private routeSubscription: Subscription;
    private routeSubscriptionReturn: Subscription;
    private currentUser: Auth;
    private colaboradoresId: ColaboradoresId[] = [];

    public persistFilter = false;

    public cartaoCadastroLote: CartaoCadastroLote;
    public cartoes: CartaoCadastro[] = [];
    public CartaoPeriodoPadrao: CartaoPeriodoPadrao;


    ngOnDestroy() {
        if (!this.persistFilter) {
            this.filterService.clear();
        }
    }

    ngOnInit() {
        this.routeSubscriptionReturn = this.route.queryParamMap.subscribe(params => {
            if (params != null) {
                this.urlReturn = params.get('urlReturn');
            }
        });

        this.currentUser = this.authenticationService.currentUserValue;
        this.colaboradorService.colaboradoresArquivoList.subscribe(ids => {
            for(var item of ids){
                this.colaboradoresId.push(item);
            }
            /* console.log("colaboradores", this.colaboradoresId) */
        });

        this.contraotoService.getAll(this.currentUser.token.assignorGuid).subscribe(
            response => {
                if (response.status === ApiError.Sucesso) {
                    if (response.result) {
                        for (const s of response.result) {
                            const cartaoNovo = new CartaoCadastro(0, CartaoPeriodoPadrao.Mensal);
                            cartaoNovo.cartaoId = 0;
                            cartaoNovo.produtoGuid = s.produtoElegibilidade.produto.produtoGuid.toLowerCase();
                            cartaoNovo.descricaoProduto = s.produtoElegibilidade.produto.descricao;
                            cartaoNovo.cedenteContratoId = s.cedenteContratoId;
                            cartaoNovo.ativo = false;
                            cartaoNovo.valorPadrao = s.valorPadrao;
                            this.cartoes.push(cartaoNovo);

                            this.cartoes = this.cartoes.sort((a, b) => a.descricaoProduto.localeCompare(b.descricaoProduto));
                        }
                    }
                } else {
                    this.alertService.error('Ocorreu um erro ao carregar os incentivos');
                }
            }
        );
    }

    onSubmit() {
        this.erroValor = false;
        let erro = false;
        this.persistFilter = true;

        let cartoesCadastro: CartaoCadastroItem[] = [];

        for (const cartao of this.cartoes){
            if (cartao.ativo) {
                if (cartao.valorPadrao <= 0) {
                    this.erroValor = true;
                } else {
                    cartoesCadastro.push(new CartaoCadastroItem(
                        cartao.cedenteContratoId,
                        cartao.valorPadrao,
                        cartao.cartaoPeriodoPadrao
                    ));
                }
            }
        }

        if(cartoesCadastro.length == 0 || this.colaboradoresId.length == 0) {
            erro = true;
        }

        if(!erro && !this.erroValor) {
            this.cartaoService.addLote(this.currentUser.token.assignorGuid, new CartaoCadastroLote(cartoesCadastro, this.colaboradoresId, null)).subscribe(
                res => {
                    if (res.status === ApiError.Sucesso){
                        this.alertService.success('Incentivos Atribuidos com sucesso');
                        if (this.urlReturn === null) {
                            this.router.navigate(['list'], { relativeTo: this.route.parent });
                        } else {
                            this.router.navigate([this.urlReturn]);
                        }
                    } else {
                        this.alertService.error('Ocorreu um erro ao registar os incentivos');
                    }
                }
            )
        } else {
            console.log(erro, this.erroValor);
            this.alertService.error('Ocorreu um erro ao registar os incentivos');
        }
    }

    previous() {
        this.persistFilter = true;
        this.router.navigate([`create-arquivo`], { relativeTo: this.route.parent });
    }

}
